<template>
  <div class="container-fluid sign-panel">
    <div class="e-sign-banner banner-div row">
      <div class="col-sm-1  col-md-1"></div>
      <div class="bannerDiv col-sm-4 col-md-4">
        <br />
        <h3 class="bannerDivone">免签名应用封装</h3>
        <br />
        <br />

        <!-- <h6 class="bannerDivtwo">不需要签名</h6> -->
        <p class="bannerDivtwo"></p>
        <h6>平台自动生成下载链接和二维码</h6>
        <p class="bannerDivtwo"></p>
        <h6>用户通过在手机上扫描二维码，即可将应用安装至手机等设备中进行测试</h6>
        <br />
        <br />
        <br />
        <!-- <el-button
          style="width:10em"
          @click="publishApp"
        >发布应用</el-button> -->
      </div>
      <div class="col-sm-6 col-md-6">
        <img class="banner-img" src="../assets/img/mianqianfengzhuang.png" />
      </div>
      <div class="bannerDiv col-sm-1 col-md-1"></div>
    </div>
    <br />
    <div class="container sign-incell">
      <form>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">ICON 图标</label>
          <div class="mx-sm-3 mb-2">
            <span class="btn btn-primary btn-upload">
              <input @change="icon_change" type="file" class="form-control" id="icon_file">选取icon图标
            </span>
          </div>
          <span class="upload-tips">{{filePath}}</span>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">应用名</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" v-model="appName">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">URL</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" v-model="appUrl">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">选择有效期</label>

          <div class="col-sm-9" style="text-align: left">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="day" value="30" checked>
              <label class="form-check-label">一个月（30天）</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="day" value="180" checked>
              <label class="form-check-label">半年</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="day" value="365">
              <label class="form-check-label">1年</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="day" value="9999">
              <label class="form-check-label">永久</label>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">允许用户删除</label>

          <div class="col-sm-9" style="text-align: left">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="isDel" value="1" checked>
              <label class="form-check-label">是</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="isDel" value="0">
              <label class="form-check-label">否</label>
            </div>
          </div>
        </div>
      </form>
      <button @click="mobileConfigAppUpload" class="btn btn-primary">开始制作</button>
      <br>
      <div v-if="startUpload" class="progress">
        <div class="progress-bar progress-bar-striped" role="progressbar" :style="'width:'+progress" aria-valuemin="0"
          aria-valuemax="100">{{progress}}</div>
      </div>
    </div>
    <MakeMobileConfigOrderDetail v-if="showMobileConfigAppOrderDetail"
      v-bind:mobileConfigAppOrder="mobileConfigAppOrder" v-on:closePayModal="closePayModal" />
  </div>
</template>

<script>
var self;
import MakeMobileConfigOrderDetail from "./MakeMobileConfigOrderDetail";
export default {
  components: {
    MakeMobileConfigOrderDetail
  },
  mounted() {
    self = this;
    var token = this.getToken();
    console.log("token ==> " + token);
    if (token != null) {
      this.getAccount(data => {});
    }
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      appName: "",
      iconFile: null,
      progress: 0,
      startUpload: false,
      appUrl: "",
      filePath: "",
      mobileConfigAppOrder: null,
      showMobileConfigAppOrderDetail: false
    };
  },
  methods: {
    icon_change: function(event) {
      var iconFile = event.target.files[0];
      this.iconFile = iconFile;
      this.filePath = event.target.value;
    },
    closePayModal: function() {
      this.showMobileConfigAppOrderDetail = false;
    },
    mobileConfigAppUpload: function() {
      if (this.iconFile == null) {
        this.$message.error({ message: "icon图标不能为空", duration: 5000 });
        return;
      }

      var allowDelete = $("input:radio[name='isDel']:checked").val();
      var day = $("input:radio[name='day']:checked").val();
      var formData = new FormData();
      formData.append("appName", this.appName);
      formData.append("iconFile", this.iconFile);
      formData.append("appUrl", this.appUrl);
      formData.append("authToken", this.getToken());
      formData.append("allowDelete", allowDelete);
      formData.append("day", day);
      let requestConfig = {
        progress: progressEvent => {
          var complete =
            (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
          this.progress = complete;
          if (complete == "100%") {
            self.successToastr("文件上传成功，系统处理完成后自动关闭");
          }
        },
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.startUpload = true;
      this.progress = 0;
      this.$http
        .post(
          this._Global.HTTP_SERVER + "/auth/mobileconfig/make",
          formData,
          requestConfig
        )
        .then(response => {
          console.log(response);
          self.respDataHandle(
            response.body,
            function(data) {
              self.mobileConfigAppOrder = data;
              self.showMobileConfigAppOrderDetail = true;
              self.startUpload = false;
            },
            () => {
              this.startUpload = false;
            }
          );
        });
    }
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .banner-img {
    margin-top: -8em;
  }
}

@media only screen and (min-width: 1200px) {
  .banner-img {
    margin-top: 6em;
    /* height: 25em; */
    width: 40em;
  }
}
#icon_file {
  border: 0;
}
.form-check {
  margin-left: 0;
  margin-right: 1em;
}
.container-fluid {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/MakeMobielConfigAppWindow.vue